import * as P from 'prop-types';

const propTypes = {
  clickToClose: P.func.isRequired,
  handleAlert: P.func.isRequired,
};

export default {
  propTypes,
  defaultProps: {},
};
